import { Box, Link, Typography } from '@mui/material';
import CollapsePlain from './Components/CollapsePlain';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';
import LtrProvider from '@Components/Common/LtrProvider';

const SingleEmail = ({ email }) => (
    <Link sx={{ fontWeight: 500 }} variant="body2" href={`mailto:${email}`}>
        {email}
    </Link>
);

export const EmailField = ({ row, field }) => {
    const { t } = useTranslation();
    const email_addresses = get(row, field, []);
    if (!email_addresses?.length) return null;
    const firstEmail = email_addresses[0];
    return (
        <Box display="flex" alignItems="center" gap={2}>
            <LtrProvider>
                <SingleEmail email={firstEmail?.email || firstEmail} />
            </LtrProvider>
            {email_addresses.length > 1 && (
                <CollapsePlain
                    tooltip={
                        <Box display="flex" flexDirection="column">
                            <Typography variant="subtitle2" gutterBottom>
                                {t('Emails')}
                            </Typography>
                            {email_addresses.map((email, index) => (
                                <LtrProvider key={index}>
                                    <SingleEmail
                                        email={email?.email || email}
                                    />
                                </LtrProvider>
                            ))}
                        </Box>
                    }
                    length={email_addresses.length}
                />
            )}
        </Box>
    );
};
